export default __webpack_public_path__ + "static/coffeeditor-0c020d433326ac590f8805b874c14200.gif";